import type { ChatRenderContext } from "@/components/shared/chat-message-types";
import { ConnectMomentInteractionThumbnail } from "@/components/conversations/connect-moment-interaction-thumbnail";
import { ConnectMomentResultCard } from "@/components/conversations/connect-moment-result-card";
import { HotTakesInteractionThumbnail } from "@/components/conversations/hot-takes-interaction-thumbnail";
import { HotTakesResultCard } from "@/components/conversations/hot-takes-result-card";
import type { HubView } from "@/components/hub/use-hub-store";
import {
  ConnectMomentUnavailableThumbnail,
  HotTakesUnavailableThumbnail,
} from "@/components/shared/entity-thumbnails";
import type { ComponentType } from "react";

export interface ActivityParticipant {
  name?: string;
  avatarUrl: string | null;
}

export interface ActivityParticipants {
  teen: ActivityParticipant;
  mentor: ActivityParticipant;
}

export interface ActivityResultCardProps<TConfig = unknown, TResult = unknown> {
  participants: ActivityParticipants;
  result: TResult;
  config: TConfig;
  onClick: () => void;
}

export interface ActivityInteractionThumbnailProps {
  entityId: string;
  index: number;
  context?: ChatRenderContext;
}

export interface ActivityUnavailableThumbnailProps {
  size?: "sm" | "md";
}

export interface ActivityClientConfig {
  hubView: HubView;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ResultCard: ComponentType<ActivityResultCardProps<any, any>>;
  InteractionThumbnail: ComponentType<ActivityInteractionThumbnailProps>;
  UnavailableThumbnail: ComponentType<ActivityUnavailableThumbnailProps>;
  featureFlag?: string;
}

export const ACTIVITY_REGISTRY: Record<string, ActivityClientConfig> = {
  hot_takes: {
    hubView: "view-hot-takes",
    ResultCard: HotTakesResultCard,
    InteractionThumbnail: HotTakesInteractionThumbnail,
    UnavailableThumbnail: HotTakesUnavailableThumbnail,
  },
  connect_moment: {
    hubView: "view-connect-moment",
    ResultCard: ConnectMomentResultCard,
    InteractionThumbnail: ConnectMomentInteractionThumbnail,
    UnavailableThumbnail: ConnectMomentUnavailableThumbnail,
    featureFlag: "activity_connect_moment",
  },
};
